<template>
    <gofix-card class="equipmentCustomField" classContent="mt-20 mb-0" classHeader="pl-23 mb-0 text-transform-none" title="Custom Field(s)">
        <b-row>
            <template v-for="(item, index) in customFields">
                <b-col class="mb-35" md="4" :key="index">
                    <template v-if="item.attribute.type === 'Checkbox'">
                        <div class="boxCustomField">
                            <b-form-checkbox v-model="item.value" value="1" @input="update"><span class="ml-21">{{item.attribute.name}}</span></b-form-checkbox>
                        </div>
                    </template>
                    <template v-if="item.attribute.type === 'Free text'">
                        <gofix-form-input class="m-0" :label="item.attribute.name" v-model="item.value" @change="update"></gofix-form-input>
                    </template>
                    <template v-if="item.attribute.type === 'Dropdown'">
                        <gofix-form-dropdown class="mb-0" :label="item.attribute.name" v-model="item.value" :options="item.attribute.possible_values" @change="update"></gofix-form-dropdown>
                    </template>
                    <template v-if="item.attribute.type == 'Reading'">
                        <div class="d-flex align-items-center">
                            <gofix-form-input-number @change="()=>{
                                let value = parseFloat(item.value);
                                if(
                                    value != null && 
                                    (
                                        (item.attribute.low_threshold != null && value < item.attribute.low_threshold) ||
                                        (item.attribute.high_threshold != null && value > item.attribute.high_threshold)
                                    )
                                ){
                                    $bvModal.msgBoxConfirm('Your value exceeds the threshold. Are you sure to keep the record?', {
                                        title: 'Warning!',
                                        size: 'sm',
                                        buttonSize: 'sm',
                                        okVariant: 'primary',
                                        okTitle: 'OK',
                                        cancelTitle: 'CANCEL',
                                        headerClass: 'p-2 border-bottom-0',
                                        footerClass: 'p-2 border-top-0',
                                        centered: true
                                    })
                                    .then(value => {
                                       if(value){
                                          item.value = parseFloat(item.value);
                                       }else{
                                          item.value = null;
                                       }
                                       update();
                                    })
                                }else{
                                  update();
                                }
                            }"
                             v-bind:class="{'row-outside-value':rowClass(item)}"
                             class="m-0" :label="item.attribute.name" allowNegative :includeThousandsSeparator="false" v-model="item.value">
                            </gofix-form-input-number>
                            <span class="ml-3 d-block min-width-105" v-if="item.unit">{{item.unit}}</span>
                        </div>
                    </template>
                    <template v-if="item.attribute.type === 'DateTime'">
                        <gofix-form-input-date
                            v-model="item.value"
                            class="mb-0"
                            popoverDirection="top"
                            desc=""
                            :label="item.attribute.name"
                            @change="update">
                        </gofix-form-input-date>
                    </template>
                </b-col>
            </template>
        </b-row>
    </gofix-card>
</template>

<script>
    import moment from 'moment';
    export default {
      name: "equipment-customfield",
      props: {
        value: {
          default: () => null
        },
      },
      data() {
        return {
          customFields: []
        };
      },
      watch: {
        value: function (val) {
          this.customFields = [];
          if (val) {
            let tableData = JSON.parse(JSON.stringify(val));
            for (let i = 0; i < tableData.length; i++) {
              if (tableData[i].attribute.type === "DateTime" && tableData[i].value) {
                tableData[i].value = new Date(tableData[i].value)
              }
            }
            this.customFields = tableData;
          }
        }
      },
      async created() {
        if (this.value) {
          let tableData = JSON.parse(JSON.stringify(this.value));
          for (let i = 0; i < tableData.length; i++) {
            if (tableData[i].attribute.type === "DateTime" && tableData[i].value) {
              tableData[i].value = new Date(tableData[i].value);
            }
          }
          this.customFields = tableData;
        }
      },
      methods: {
        update() {
          let data = [];
          for (let i = 0; i < this.customFields.length; i++) {
            let item = Object.assign({}, this.customFields[i]);//JSON.parse(JSON.stringify(
            if (item.attribute.type === "DateTime" && item.value) {
              item.value = moment(item.value).format("YYYY-MM-DD");
              if(item.attribute.name == 'Lift Turn On Date') this.$emit("changeLiftOnTurnDate", item.value);
            }
            data.push(item)
          }
          this.$emit("input", data);
        },
        rowClass(item, type) {
          if (item) {
            if (item.value != null) {
              let value = parseFloat(item.value);
              let high_threshold = parseFloat(item.attribute.high_threshold);
              let low_threshold = parseFloat(item.attribute.low_threshold);
              if (value < low_threshold || value > high_threshold) {
                return true;
              }
            }
          }
          return false;
        },
      }
    }
</script>
